import I18n from 'I18n';
import { UserTicketStatusOption, UserTicketViewOption } from '../data/types';
import { getDateRangeDescription } from '../utils/getDateRangeDescription';
export let TicketListingView;
(function (TicketListingView) {
  TicketListingView["GRID"] = "grid";
  TicketListingView["TABLE"] = "table";
})(TicketListingView || (TicketListingView = {}));
export let DateFilterType;
(function (DateFilterType) {
  DateFilterType["TODAY"] = "today";
  DateFilterType["YESTERDAY"] = "yesterday";
  DateFilterType["LAST_7_DAYS"] = "last_7_days";
  DateFilterType["LAST_30_DAYS"] = "last_30_days";
  DateFilterType["THIS_WEEK"] = "this_week";
  DateFilterType["THIS_MONTH"] = "this_month";
  DateFilterType["LAST_MONTH"] = "last_month";
  DateFilterType["THIS_QUARTER"] = "this_quarter";
  DateFilterType["LAST_QUARTER"] = "last_quarter";
  DateFilterType["YEAR_TO_DATE"] = "year_to_date";
  DateFilterType["ALL_TIME"] = "all_time";
})(DateFilterType || (DateFilterType = {}));
export const DEFAULT_FILTER_VALUES = {
  statusFilter: UserTicketStatusOption.ALL,
  ticketView: UserTicketViewOption.PERSONAL,
  createDateFilter: DateFilterType.ALL_TIME,
  lastActivityFilter: DateFilterType.ALL_TIME
};
export const DEFAULT_SORT_VALUE = ['-createdate'];
export const getDateFilterLabel = filter => {
  switch (filter) {
    case DateFilterType.TODAY:
      return I18n.text('customer-portal-app.dateFilter.today');
    case DateFilterType.YESTERDAY:
      return I18n.text('customer-portal-app.dateFilter.yesterday');
    case DateFilterType.LAST_7_DAYS:
      return I18n.text('customer-portal-app.dateFilter.last_7_days');
    case DateFilterType.LAST_30_DAYS:
      return I18n.text('customer-portal-app.dateFilter.last_30_days');
    case DateFilterType.THIS_WEEK:
      return I18n.text('customer-portal-app.dateFilter.this_week');
    case DateFilterType.THIS_MONTH:
      return I18n.text('customer-portal-app.dateFilter.this_month');
    case DateFilterType.LAST_MONTH:
      return I18n.text('customer-portal-app.dateFilter.last_month');
    case DateFilterType.THIS_QUARTER:
      return I18n.text('customer-portal-app.dateFilter.this_quarter');
    case DateFilterType.LAST_QUARTER:
      return I18n.text('customer-portal-app.dateFilter.last_quarter');
    case DateFilterType.YEAR_TO_DATE:
      return I18n.text('customer-portal-app.dateFilter.year_to_date');
    case DateFilterType.ALL_TIME:
      return I18n.text('customer-portal-app.dateFilter.all_time');
    default:
      return filter;
  }
};
export const generateStatusFilterOptions = () => [{
  text: I18n.text('customer-portal-app.filter.all'),
  value: UserTicketStatusOption.ALL
}, {
  text: I18n.text('customer-portal-app.filter.open'),
  value: UserTicketStatusOption.OPEN
}, {
  text: I18n.text('customer-portal-app.filter.closed'),
  value: UserTicketStatusOption.CLOSED
}];
export const generateDateFilterOptions = () => [{
  text: getDateFilterLabel(DateFilterType.TODAY),
  value: DateFilterType.TODAY,
  help: getDateRangeDescription(DateFilterType.TODAY)
}, {
  text: getDateFilterLabel(DateFilterType.YESTERDAY),
  value: DateFilterType.YESTERDAY,
  help: getDateRangeDescription(DateFilterType.YESTERDAY)
}, {
  text: getDateFilterLabel(DateFilterType.LAST_7_DAYS),
  value: DateFilterType.LAST_7_DAYS,
  help: getDateRangeDescription(DateFilterType.LAST_7_DAYS)
}, {
  text: getDateFilterLabel(DateFilterType.LAST_30_DAYS),
  value: DateFilterType.LAST_30_DAYS,
  help: getDateRangeDescription(DateFilterType.LAST_30_DAYS)
}, {
  text: getDateFilterLabel(DateFilterType.THIS_WEEK),
  value: DateFilterType.THIS_WEEK,
  help: getDateRangeDescription(DateFilterType.THIS_WEEK)
}, {
  text: getDateFilterLabel(DateFilterType.THIS_MONTH),
  value: DateFilterType.THIS_MONTH,
  help: getDateRangeDescription(DateFilterType.THIS_MONTH)
}, {
  text: getDateFilterLabel(DateFilterType.LAST_MONTH),
  value: DateFilterType.LAST_MONTH,
  help: getDateRangeDescription(DateFilterType.LAST_MONTH)
}, {
  text: getDateFilterLabel(DateFilterType.THIS_QUARTER),
  value: DateFilterType.THIS_QUARTER,
  help: getDateRangeDescription(DateFilterType.THIS_QUARTER)
}, {
  text: getDateFilterLabel(DateFilterType.LAST_QUARTER),
  value: DateFilterType.LAST_QUARTER,
  help: getDateRangeDescription(DateFilterType.LAST_QUARTER)
}, {
  text: getDateFilterLabel(DateFilterType.YEAR_TO_DATE),
  value: DateFilterType.YEAR_TO_DATE,
  help: getDateRangeDescription(DateFilterType.YEAR_TO_DATE)
}, {
  text: getDateFilterLabel(DateFilterType.ALL_TIME),
  value: DateFilterType.ALL_TIME
}];
export const generateDateFilter = (propertyName, type) => {
  if (type === DateFilterType.TODAY) {
    return {
      propertyName,
      start: I18n.moment.userTz().startOf('day').toDate().getTime(),
      end: I18n.moment.userTz().endOf('day').toDate().getTime()
    };
  }
  if (type === DateFilterType.YESTERDAY) {
    return {
      propertyName,
      start: I18n.moment.userTz().subtract(1, 'day').startOf('day').toDate().getTime(),
      end: I18n.moment.userTz().subtract(1, 'day').endOf('day').toDate().getTime()
    };
  }
  if (type === DateFilterType.LAST_7_DAYS) {
    return {
      propertyName,
      start: I18n.moment.userTz().subtract(7, 'days').startOf('day').toDate().getTime(),
      end: I18n.moment.userTz().endOf('day').toDate().getTime()
    };
  }
  if (type === DateFilterType.LAST_30_DAYS) {
    return {
      propertyName,
      start: I18n.moment.userTz().subtract(30, 'days').startOf('day').toDate().getTime(),
      end: I18n.moment.userTz().endOf('day').toDate().getTime()
    };
  }
  if (type === DateFilterType.THIS_WEEK) {
    return {
      propertyName,
      start: I18n.moment.userTz().startOf('week').toDate().getTime(),
      end: I18n.moment.userTz().endOf('day').toDate().getTime()
    };
  }
  if (type === DateFilterType.THIS_MONTH) {
    return {
      propertyName,
      start: I18n.moment.userTz().startOf('month').toDate().getTime(),
      end: I18n.moment.userTz().endOf('month').toDate().getTime()
    };
  }
  if (type === DateFilterType.LAST_MONTH) {
    return {
      propertyName,
      start: I18n.moment.userTz().subtract(1, 'month').startOf('month').toDate().getTime(),
      end: I18n.moment.userTz().subtract(1, 'month').endOf('month').toDate().getTime()
    };
  }
  if (type === DateFilterType.THIS_QUARTER) {
    return {
      propertyName,
      start: I18n.moment.userTz().startOf('quarter').toDate().getTime(),
      end: I18n.moment.userTz().endOf('quarter').toDate().getTime()
    };
  }
  if (type === DateFilterType.LAST_QUARTER) {
    return {
      propertyName,
      start: I18n.moment.userTz().subtract(1, 'quarter').startOf('quarter').toDate().getTime(),
      end: I18n.moment.userTz().subtract(1, 'quarter').endOf('quarter').toDate().getTime()
    };
  }
  if (type === DateFilterType.YEAR_TO_DATE) {
    return {
      propertyName,
      start: I18n.moment.userTz().startOf('year').toDate().getTime(),
      end: I18n.moment.userTz().endOf('year').toDate().getTime()
    };
  }
  if (type === DateFilterType.ALL_TIME) {
    return null;
  }
};